import angular from "angular";

angular
    .module('importantNotice', [])
    .component('importantNotice', {
        template: require('./important-notice.html'),
        controller: ['$timeout', '$rootScope', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($timeout, $rootScope, $http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.article = $ctrl.resolve.article;
        $timeout(function () {
            $http
                .post('/press/' + $ctrl.article.id + '/opened')
                .then(function () {
                    $rootScope.$emit('article.opened', {articleId: $ctrl.article.id});
                });
        }, 1500);
    };

}

export default 'importantNotice';


// WEBPACK FOOTER //
// ./resources/assets/modules/important-notice/important-notice.js